<template>
<v-container>
   <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>

    </v-app-bar>
  </nav>

  <template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left" style="color:white;">
            DB Board
          </th>
          <th class="text-left" style="color:white;">
            Phase Label
          </th>
          <th class="text-left" style="color:white;">
            Location (Room by Google)
          </th>
          <th class="text-left" style="color:white;">
            8CH Current Sensor Label
          </th>
          <th class="text-left" style="color:white;">
            8CH CS Individual Channel Label
          </th>
          <th class="text-left" style="color:white;">
            8CH Current Sensor S/N
          </th>
          <th class="text-left" style="color:white;">
            Modbus Address
          </th>
          <th class="text-left" style="color:white;">
            Load Type 
          </th>
 
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1A.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1A.length === 0">No Location</span><span v-else>{{ item.loc1A[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1B.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1B.length === 0">No Location</span><span v-else>{{ item.loc1B[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1C.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1C.length === 0">No Location</span><span v-else>{{ item.loc1C[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1D.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1D.length === 0">No Location</span><span v-else>{{ item.loc1D[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1E.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1E.length === 0">No Location</span><span v-else>{{ item.loc1E[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1F.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1F.length === 0">No Location</span><span v-else>{{ item.loc1F[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1G.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1G.length === 0">No Location</span><span v-else>{{ item.loc1G[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb1H.label }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc1H.length === 0">No Location</span><span v-else>{{ item.loc1H[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn1 }}</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">1</td>
          <td v-if="board[0].totalSensor == 1 || board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_1H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2A.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2A.length === 0">No Location</span><span v-else>{{ item.loc2A[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2B.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2B.length === 0">No Location</span><span v-else>{{ item.loc2B[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2C.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2C.length === 0">No Location</span><span v-else>{{ item.loc2C[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2D.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2D.length === 0">No Location</span><span v-else>{{ item.loc2D[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2E.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2E.length === 0">No Location</span><span v-else>{{ item.loc2E[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2F.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2F.length === 0">No Location</span><span v-else>{{ item.loc2F[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2G.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2G.length === 0">No Location</span><span v-else>{{ item.loc2G[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb2H.label }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc2H.length === 0">No Location</span><span v-else>{{ item.loc2H[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn2 }}</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">2</td>
          <td v-if="board[0].totalSensor == 2 || board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_2H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3A.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3A.length === 0">No Location</span><span v-else>{{ item.loc3A[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3B.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3B.length === 0">No Location</span><span v-else>{{ item.loc3B[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3C.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3C.length === 0">No Location</span><span v-else>{{ item.loc3C[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3D.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3D.length === 0">No Location</span><span v-else>{{ item.loc3D[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3E.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3E.length === 0">No Location</span><span v-else>{{ item.loc3E[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3F.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3F.length === 0">No Location</span><span v-else>{{ item.loc3F[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3G.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3G.length === 0">No Location</span><span v-else>{{ item.loc3G[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.boardName3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.ryb3H.label }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4"><span v-if="item.loc3H.length === 0">No Location</span><span v-else>{{ item.loc3H[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorLabel3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.chSensorSn3 }}</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">3</td>
          <td v-if="board[0].totalSensor == 3 || board[0].totalSensor == 4">{{ item.loadType_3H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4A.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4A.length === 0">No Location</span><span v-else>{{ item.loc4A[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">A</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4A.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
      <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4B.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4B.length === 0">No Location</span><span v-else>{{ item.loc4B[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">B</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4B.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4C.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4C.length === 0">No Location</span><span v-else>{{ item.loc4C[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">C</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4C.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4D.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4D.length === 0">No Location</span><span v-else>{{ item.loc4D[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">D</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4D.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4E.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4E.length === 0">No Location</span><span v-else>{{ item.loc4E[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">E</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4E.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4F.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4F.length === 0">No Location</span><span v-else>{{ item.loc4F[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">F</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4F.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4G.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4G.length === 0">No Location</span><span v-else>{{ item.loc4G[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">G</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4G.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
       <tbody>
        <tr
          v-for="item in board"
          :key="item.chConsoleLabel"
        >
          <td v-if="board[0].totalSensor == 4">{{ item.boardName4 }}</td>
          <td v-if="board[0].totalSensor == 4">{{ item.ryb4H.label }}</td>
          <td v-if="board[0].totalSensor == 4"><span v-if="item.loc4H.length === 0">No Location</span><span v-else>{{ item.loc4H[0].location }}</span></td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorLabel4 }}</td>
          <td v-if="board[0].totalSensor == 4">H</td>
          <td v-if="board[0].totalSensor == 4">{{ item.chSensorSn4 }}</td>
          <td v-if="board[0].totalSensor == 4">4</td>
          <td v-if="board[0].totalSensor == 4">{{ item.loadType_4H.map(({loadType,quantity}) => loadType +' '+ 'x' + ' ' + quantity).join(' ') }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <p>{{loadTypeA}}</p> -->
   
</template>
<v-btn fixed dark fab bottom right color="green" :to="{ name: 'Board Edit', params: { id: this.$route.params.id } }">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
</v-container>
</template>

<script>
import axios from "axios";

  export default {
    data () {
      return {
        items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: '8 Channel Phase',
          disabled: false,
          href: '/board',
        },
        {
          text: 'Details',
          disabled: true,
          href: '',
        },
      ],
        board: []
      }
    },
    mounted() {
    this.loadsBoard();
  },
    methods:{
      loadsBoard: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/board/" + this.$route.params.id;
      axios.get(apiURL).then(res => {
      this.board = res.data;
      }).catch(error => {
      console.log(error)
      });
},
    }
  }
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>